import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

import { Ticket } from '../ticket-management.component';

@Component({
  selector: 'app-ticket-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MatMenuModule,
    MatButtonModule
  ],
  templateUrl: './ticket-table.component.html',
  styleUrls: ['./ticket-table.component.css']
})
export class TicketTableComponent implements OnInit, OnChanges {
  @Input() tickets: Ticket[] = [];
  @Input() columns: any[] = [];
  @Output() viewEvent = new EventEmitter<Ticket>();
  @Output() viewStatusEvent = new EventEmitter<Ticket>();
  @Output() commentEvent = new EventEmitter<Ticket>();
  @Output() editEvent = new EventEmitter<Ticket>();
  @Output() deleteEvent = new EventEmitter<Ticket>();
  @Output() statusChangeEvent = new EventEmitter<{ticket: Ticket, newStatus: string}>();

  searchValue: string = '';
  statusOptions = [
    { label: 'Open', value: 'Open' },
    { label: 'In Progress', value: 'In Progress' },
    { label: 'Resolved', value: 'Resolved' },
    { label: 'Closed', value: 'Closed' },
    { label: 'Re-open', value: 'Re-open' }
  ];

  filteredTickets: Ticket[] = [];
  rowsPerPage: number = 10;
  first: number = 0;

  ngOnInit(): void {
    this.filteredTickets = [...this.tickets];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tickets'] && this.tickets) {
      this.filteredTickets = [...this.tickets];
    }
  }

  onGlobalFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchValue = value;
    this.filteredTickets = this.tickets.filter(ticket => {
      return Object.values(ticket).some(val => 
        val?.toString().toLowerCase().includes(value.toLowerCase())
      );
    });
  }

  onStatusChange(ticket: Ticket, newStatus: string): void {
    ticket.status = newStatus;
    this.statusChangeEvent.emit({ ticket, newStatus });
  }

  getPriorityClass(priority: string): string {
    switch(priority?.toLowerCase()) {
      case 'high':
        return 'bg-red-100 text-red-800';
      case 'medium':
        return 'bg-yellow-100 text-yellow-800';
      case 'low':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  formatDate(date: Date | string | undefined): string {
    if (!date) return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toISOString().split('T')[0];
  }
}

